import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import BankSoalRepository from '../Repositories/BankSoalRepository'


class BankSoalBloc
{
    repository = new BankSoalRepository()
    bankSoalDatatableChannel = new Subject()
    bankSoalSubmitChannel = new Subject()
    bankSoalDeleteChannel = new Subject()
    bankSoalActivateChannel = new Subject()
    bankSoalImportChannel = new Subject()
    bankSoalOptionChannel = new Subject()
    bankSoalCompetenceChannel = new Subject()

    constructor() {
        this.bankSoalDatatableChannel.next({status: apiResponse.INITIAL})
        this.bankSoalSubmitChannel.next({status: apiResponse.INITIAL})
        this.bankSoalDeleteChannel.next({status: apiResponse.INITIAL})
        this.bankSoalActivateChannel.next({status: apiResponse.INITIAL})
        this.bankSoalImportChannel.next({status: apiResponse.INITIAL})
        this.bankSoalOptionChannel.next({status: apiResponse.INITIAL})
        this.bankSoalCompetenceChannel.next({status: apiResponse.INITIAL})
    }

    fetchCompetence = async (query) => {
        this.bankSoalCompetenceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCompetence(query).then((result) => {
            this.bankSoalCompetenceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.bankSoalCompetenceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    

    fetchOption = async (query) => {
        this.bankSoalOptionChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchOption(query).then((result) => {
            this.bankSoalOptionChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.bankSoalOptionChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    
    fetchDataTable = async (query, cancelToken) => {
        this.bankSoalDatatableChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDataTable(query, cancelToken).then((result) => {
            this.bankSoalDatatableChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.bankSoalDatatableChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSubmit = async (query) => {
        this.bankSoalSubmitChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSubmit(query).then((result) => {
            this.bankSoalSubmitChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.bankSoalSubmitChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDelete = async (query) => {
        this.bankSoalDeleteChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDelete(query).then((result) => {
            this.bankSoalDeleteChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.bankSoalDeleteChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchActivate = async (query) => {
        this.bankSoalActivateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchActivate(query).then((result) => {
            this.bankSoalActivateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.bankSoalActivateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchImport = async (query) => {
        this.bankSoalImportChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchImport(query).then((result) => {
            this.bankSoalImportChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.bankSoalImportChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
   

}

export default BankSoalBloc